export interface ValidationResult {
    valid: boolean;
    error?: string;
}

export const FileValidationService = Symbol.for('FileValidationService');

/**
 * 文件验证服务
 * 负责验证文件类型、大小等基本属性
 */
export interface FileValidationService {
    /**
     * 验证文件是否符合上传要求
     * @param file 要验证的文件
     * @returns 验证结果
     */
    validateFile(file: File): ValidationResult;
}
